import React from "react";

interface AppointmentCounterTextProps {
    appointmentCount: number;
}

export const AppointmentCounterText: React.FC<AppointmentCounterTextProps> = ({ appointmentCount }) => {
    return <span className={"description-text"}>총 {appointmentCount}개</span>
}